import { useContext, useEffect, useRef, useState } from "react";
import PageToolbar from "../../global-components/pageToolbar";
import PageSizeDropdown from "../../global-components/pageSizeDropDown";
import NewPaginationContainer from "../../global-components/new-pagination";
import { lmsLineItemsPriority } from "../../../constants";
import NoDataFound from "../../global-components/no-data-found";
import { fetchLmsLineItemsList } from "../../../api/lms";
import searchIcon from '../../../assets/icons/InputIcon.svg';
import { lmsStatusChips } from "../../../utils/utils";
import whiteSearchIcon from '../../../assets/icons/InputWhiteIcon.svg';
import FilterNavLmsLineItems from "./filtersNav";
import { formatDateWithDashes } from "../../../utils/helper";
import { Link } from "react-router-dom";
import { AbilityContext } from "../../../context/AbilityContext";

interface Props {
  itemView?: boolean;
  barcodeValue?: any;
}

function LmsLineItemsContainer({ itemView, barcodeValue }: Props) {
  const ability = useContext(AbilityContext);
  const ref = useRef<any>()
  const [itemList, setitemList] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(25);
  const pageSizeOptions: number[] = [25, 50, 75, 100, 125];
  const [origin, setOrigin] = useState("");
  const [site, setSite] = useState("");
  const [barCodeNo, setBarCodeNo] = useState(barcodeValue ? barcodeValue : "");
  const [priority, setpriority] = useState("");
  const [searchText, setSearchText] = useState('');
  const [handleToggleChange, setHandleToggleChange] = useState(false);
  const [postingDate, setPostingDate] = useState<{
    startDate: Date | null;
    endDate: Date | null;
  }>({
    startDate: null,
    endDate: null,
  });
  const [selectedDates, setSelectedDates] = useState<{
    startDate: Date | null;
    endDate: Date | null;
  }>({
    startDate: null,
    endDate: null,
  });

  function getPriorityLabel(value: any) {
    const priority = lmsLineItemsPriority.find((p) => p.value === value);
    return priority ? priority.label : value;
  }

  const fetchData = (searchText?: string) => {
    let payload = {
      page: currentPage,
      pageSize: pageSize,
      job_no: "",
      search: searchText ? searchText : "",
      is_pagination: true,
      order_date:
        selectedDates?.startDate &&
        selectedDates?.endDate &&
        `${selectedDates?.startDate
          ? formatDateWithDashes(selectedDates.startDate)
          : ""
        }|${selectedDates?.endDate
          ? formatDateWithDashes(selectedDates.endDate)
          : ""
        }`,
      posting_date:
        postingDate?.startDate &&
        postingDate?.endDate &&
        `${postingDate?.startDate
          ? formatDateWithDashes(postingDate.startDate)
          : ""
        }|${postingDate?.endDate
          ? formatDateWithDashes(postingDate.endDate)
          : ""
        }`,
      origin: origin !== "" ? origin : undefined,
      site: site !== "" ? site : undefined,
      priority: priority !== "" ? priority : undefined,
      barcode: barCodeNo !== "" ? barCodeNo : undefined,
    };
    setLoading(true);
    fetchLmsLineItemsList(payload)
      .then((response: any) => {
        if (!response?.data?.is_error) {

          const updatedContent = response?.data?.content.map((item: any) => ({
            ...item,
            carriers: item.transfer_carriers,
          }));
          const updatedResponseContent = {
            ...response.data.content,
            data: updatedContent,
          };

          setitemList(updatedResponseContent);
          setHandleToggleChange(false);
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };


  useEffect(() => {
    fetchData();
  }, [currentPage, pageSize]);

  const handleSearchField = (query: string) => {
    fetchData(query);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      handleSearchField((event.target as HTMLInputElement).value);
    }}
    
  return (
    <div className={!itemView ? 'container-fluid mt-2 my-4' : ''}>
      <div className={!itemView ? 'row mb-5' : ''}>
        <div className="col-12">
          <div className={!itemView ? 'card-body p-4' : ''}>
            {!itemView &&
              <FilterNavLmsLineItems
                origin={origin}
                setOrigin={setOrigin}
                selectedDates={selectedDates}
                setSelectedDates={setSelectedDates}
                site={site}
                setSite={setSite}
                priority={priority}
                setpriority={setpriority}
                priorityList={lmsLineItemsPriority}
                handleToggleChange={handleToggleChange}
                setHandleToggleChange={setHandleToggleChange}
                handleFilter={fetchData}
                postingDate={postingDate}
                setPostingDate={setPostingDate}
                barCodeNo={barCodeNo}
                setBarCodeNo={setBarCodeNo}
              />
            }

            <div className="">
              {!itemView &&
              <div style={{display : "flex" , gap : "15px"}}>
               <div className='input-group relative' style={{width : "331px" , paddingBottom : "10px"}}>
               <input
                 className='form-control ubbe-input'
                 style={{ paddingRight: '45px' }}
                 id={'search-field'}
                 placeholder={'Search here'}
                 ref = {ref}
                 onKeyPress={handleKeyDown}
               />
                 <span
                   className='input-group-text searchIcon'
                   id='button-addon2'
                 >
                   
                   <img 
                    className="cursor-pointer" src={searchIcon} alt={searchIcon} />
                 </span>
                
              </div>
              <div className="d-flex flex-column" style={{paddingBottom : "10px"}}>
          <button
            type="button"
            style={{ width: "60px"}}
            className={
             "active-filter mt-auto "
            
            }
            onClick={() => handleSearchField(ref?.current?.value)}
          >                  
          <img className="cursor-pointer searchIcon-lms" src={whiteSearchIcon} alt={whiteSearchIcon} />
          </button>
        </div>
              </div>
              }
              <div style={{ overflowX: 'auto' }}>
                <table className={!itemView ? 'table mt-3' : 'table'} id="lms_items_table" style={{ minWidth: '1800px' }}>
                  <thead className="ubbe-table-header">
                    <tr>
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope="col"
                        style={{ width: "12%" }}
                      >
                        Order Date
                      </th>
                      <th className={`text-start align-middle ubbe-table-heading-text`}
                        scope="col" style={{ width: "16%" }} >Posting Date</th>
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope="col"
                        style={{ width: "20%" }}
                      >
                        Description
                      </th>
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope="col"
                        style={{ width: "10%" }}
                      >
                        PO#
                      </th>

                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope="col"
                      >
                        Barcode
                      </th>
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope="col"
                        style={{ width: "10%" }}
                      >
                        Quantity Ordered
                      </th>
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope="col"
                        style={{ width: "10%" }}
                      >
                        Quantity Received
                      </th>
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope="col"
                      >
                        Origin
                      </th>
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope="col"
                      >
                        Site
                      </th>
                      <th
                        className={`text-start align-middle ubbe-table-heading-text`}
                        scope="col"
                        style={{ width: "12%" }}
                      >
                        Priority
                      </th>
                      <th className={`text-start align-middle ubbe-table-heading-text`}
                        scope="col" style={{ width: "10%" }} >Buyer</th>
                      <th className={`text-start align-middle ubbe-table-heading-text`}
                        scope="col" style={{ width: "10%" }}>Unit Price</th>

                    </tr>
                  </thead>
                  <tbody id="set_lanes_rows" className="bg-white">
                    {loading ? (
                      <tr className="text-center">
                        <td colSpan={20}>
                          <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    ) :
                    itemList && itemList.data && itemList.data.length > 0 ? (
                      itemList?.data?.map((item: any) => (
                        <tr>
                          <td className="align-middle">
                            {item?.order_date ? item?.order_date : "N/A"}
                          </td>
                          <td className="align-middle">
                            {item?.posting_date ? item?.posting_date : "N/A"}
                          </td>
                          <td className="align-middle text-break">
                            {item?.description ? item?.description : "N/A"}
                            <br />
                            {item?.description_2 && item?.description_2}
                          </td>

                          <td className="align-middle">
                            {item?.vendor_order_no
                              ? item?.vendor_order_no
                              : "N/A"}
                          </td>
                          <td className="align-middle text-break ">
                            {/* {item?.package_tracking_no
                              ? item?.package_tracking_no
                              : "N/A"} */}
                            {!itemView && item?.bbe_manifest_item_no && item?.package_tracking_no && ability.can('read', 'LMS Item View') ?
                              <Link
                                className="text-decoration-none"
                                to={`/app/warehouse/items/view?item_no=${item?.bbe_manifest_item_no}&barcode=${item?.package_tracking_no}`}
                              >
                                <u
                                  className="labelText"
                                  style={{ color: "#251163", fontSize: "16px" }}
                                >
                                  {item?.package_tracking_no ? item?.package_tracking_no : "N/A"}
                                </u>
                              </Link>
                              :
                              item?.package_tracking_no
                                ? item?.package_tracking_no
                                : "N/A"
                            }
                          </td>

                          <td className="align-middle" style={{ textAlign: 'center' }}>
                            {item?.quantity ? item?.quantity : "N/A"}
                          </td>
                          <td className="align-middle" style={{ textAlign: 'center' }}>
                            {item?.quantity_received
                              ? item?.quantity_received
                              : "N/A"}
                          </td>
                          <td className="align-middle">
                            {item?.origin_location_code
                              ? item?.origin_location_code
                              : "N/A"}
                          </td>
                          <td className="align-middle">
                            {item?.site ? item?.site : "N/A"}
                          </td>
                          <td className="align-middle">
                            {item?.priority
                              ? lmsStatusChips(getPriorityLabel(item?.priority))
                              : "N/A"}
                          </td>

                          <td className="align-middle">
                            {item?.lms_buyer_initials ? item?.lms_buyer_initials : "N/A"}
                          </td>
                          <td className="align-middle">
                            {item?.unit_price ? item?.unit_price : "N/A"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <tr>
                          <td
                            colSpan={12}
                            className="text-center global-text align-middle "
                            style={{ color: " #979797                      " }}
                          >
                            <NoDataFound />
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>

            </div>
            <div className="d-flex justify-content-end align-items-center gap-2">
              <>
                {itemList?.count > 25 && (
                  <PageSizeDropdown
                    setPageSize={setPageSize}
                    pageSizeOptions={pageSizeOptions}
                    currentSize={pageSize}
                    setCurrentPage={setCurrentPage}
                  />
                )}
                {itemList?.pages > 1 && (
                  <div className="d-flex align-items-center justify-content-end gap-3">
                    <NewPaginationContainer
                      totalItems={itemList?.count}
                      totalPages={itemList?.pages}
                      currentPage={currentPage}
                      pageSize={pageSize}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                )}{" "}
              </>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LmsLineItemsContainer;
